import { Permission } from '@/types';
import type { Component } from 'vue';

export interface DashboardItem {
    title: string;
    description: string;
    tooltip?: string;
    permission?: Permission;
    routeName?: string;
    icon: Component;
}
